import { FC } from "react";

import Stack from "@mui/material/Stack";
import { AvailablePaymentCurrency } from "@simplyk/common";

import { PrizeImage } from "../../components/PrizeImage/PrizeImage";
import { PrizeValue } from "../../components/PrizeValue/PrizeValue";
import { TicketingPrizeOutput } from "../../types";

import { PrizeDescription } from "./PrizeDescription/PrizeDescription";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormDialog } from "@/forms-design-system/FormDialog";
import { FormTypography } from "@/forms-design-system/FormTypography";

interface PrizeDetailsDialogProps {
  prize: TicketingPrizeOutput | null;
  currency: AvailablePaymentCurrency;
  onClose: () => void;
  inline?: boolean;
}

export const PrizeDetailsDialog: FC<PrizeDetailsDialogProps> = ({ prize, currency, onClose, inline = false }) => {
  const { t } = useTranslate();
  const { isSmallScreen } = useMediaQuery();

  if (!prize) {
    return null;
  }

  return (
    <FormDialog
      open
      inline={inline}
      onClose={onClose}
      size="xs"
      variant={isSmallScreen ? "drawer" : "default"}
      title={null}
    >
      <Stack gap={2} data-test="prize-details-dialog">
        {prize.photoUrl && (
          <PrizeImage
            photoUrl={prize.photoUrl}
            alt={t("common", "a11y.itemPhoto", { item: prize.title })}
            sx={{ width: "100%" }}
          />
        )}
        <Stack gap={0.5}>
          <FormTypography variant="h6" vibe="intense" component="h3">
            {prize.title}
          </FormTypography>
          {prize.value !== null && <PrizeValue value={prize.value} currency={currency} />}
        </Stack>
        {prize.description && <PrizeDescription description={prize.description} />}
      </Stack>
    </FormDialog>
  );
};
